type MappedProps<Props> = { [K in keyof Props]: Props[K] }

/**
 * Example, given an object of variants like:
 *  {
 *      green : {
 *          color: 'green'
 *      }
 *  }
 *
 *  Will inject the prefix into green, give prefix for hover: `&:hover`:
 *  {
 *      green : {
 *          '&:hover' : {
 *              color: 'green'
 *          }
 *      }
 *  }
 *
 * @param v
 * @param prefix
 */
export const generateVariantsWithPrefix = <Props>(
  v: MappedProps<Props>,
  prefix: string
): MappedProps<Props> => {
  const variantKeys = Object.keys(v)

  const newVariants = {}

  variantKeys.forEach(vk => {
    const variantValuesKeys = Object.keys(v[vk])
    const newVariantValue = {}

    variantValuesKeys.forEach(vv => {
      Object.assign(newVariantValue, { [prefix]: { [vv]: v[vk][vv] } })
    })

    Object.assign(newVariants, { [vk]: newVariantValue })
  })

  return newVariants as MappedProps<Props>
}
